import { render, staticRenderFns } from "./TabelaSegmentacao.vue?vue&type=template&id=7c440102&"
import script from "./TabelaSegmentacao.vue?vue&type=script&lang=js&"
export * from "./TabelaSegmentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports